import { webfontBaseUrl } from 'elements/icon/font-awesome/v6.5.1/webfont-base-url.js'
import { css, CSSResult } from 'lit'


/*!
 * Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2023 Fonticons, Inc.
 */
export const faRegular: CSSResult = css`
  :root, :host {
    --fa-style-family-classic: 'Font Awesome 6 Pro';
    --fa-font-regular: normal 400 1em/1 'Font Awesome 6 Pro'; 
  }
  
  @font-face {
    font-family: 'Font Awesome 6 Pro';
    font-style: normal;
    font-weight: 400;
    font-display: block;
    src: url("${webfontBaseUrl}/fa-regular-400.woff2") format("woff2"), url("${webfontBaseUrl}/fa-regular-400.ttf") format("truetype"); 
  }`

// Split to allow the @font-face to be loaded at the document level,
// while the class styles are loaded at the element level.
export const faRegularClass: CSSResult = css`
  .far,
  .fa-regular {
    font-weight: 400; 
  }`
